import { render, staticRenderFns } from "./ContentDiscoveryList.vue?vue&type=template&id=f542c7cc&scoped=true&"
import script from "./ContentDiscoveryList.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoveryList.vue?vue&type=script&lang=js&"
import style0 from "./ContentDiscoveryList.vue?vue&type=style&index=0&id=f542c7cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f542c7cc",
  null
  
)

export default component.exports